import { sessionLinkDefaults, type ProgramLinkSource } from "@/functions-shared/offer/sessionLinkDefaults";

/** The two session-form links a program pre-fills. (Program website is read-only, copied on save.) */
export const PREFILLED_SESSION_LINKS = ["url", "regUrl"] as const;
export type PrefilledSessionLink = (typeof PREFILLED_SESSION_LINKS)[number];

/**
 * KB-4351 — the one place a session form maps program links onto its inputs. Every pre-fill site (the
 * offer dialog, bulk add sessions, the session dialog) calls this instead of naming fields itself, so
 * no call site can wire the program page into `url`. Each site decides only WHETHER to write a field
 * (`shouldWrite`), never WHAT goes in it.
 */
export function prefillSessionLinks(
  program: ProgramLinkSource | null | undefined,
  write: (field: PrefilledSessionLink, value: string) => void,
  shouldWrite: (field: PrefilledSessionLink, value: string) => boolean = () => true,
): void {
  const defaults = sessionLinkDefaults(program);
  for (const field of PREFILLED_SESSION_LINKS) {
    const value = defaults[field];
    if (shouldWrite(field, value)) write(field, value);
  }
}
